import { object, number, string, create } from 'superstruct'

export const CreateParams = object({
  id: number(),
  name: string()
})

export class Professor {
  static create(params) {
    return new Professor(create(params, CreateParams))
  }

  constructor(params) {
    Object.assign(this, params)
  }
}
